(() => {
  const $ = (s) => document.querySelector(s), $$ = (s) => [...document.querySelectorAll(s)];
  const tl = (n) => n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'TL';
  const loop = (el, items) => (el.innerHTML = Array(4).fill(items).flat().map((t) => `<span>${t}</span>`).join(''));
  loop($('#ann'), ['Kapıda Ödeme İmkanı', 'Kışa ve Soğuğa Yenilmeyin', 'Ücretsiz Kargo']);
  loop($('#tick'), ['Üşümeyi Durdurun!', '5 Çift Alana 3 Hediye 🎁', 'Rahat Bir Kış Geçirin!']);

  // galeri
  const slides = $('#slides'), imgs = $$('#slides img');
  imgs.forEach((im, i) => $('#thumbs').insertAdjacentHTML('beforeend', `<button type="button" class="${i ? '' : 'on'}" aria-label="Görsel ${i + 1}"><img src="${im.getAttribute('src')}" alt=""></button>`));
  const cur = () => Math.round(slides.scrollLeft / slides.clientWidth);
  const go = (i) => slides.scrollTo({ left: slides.clientWidth * ((i + imgs.length) % imgs.length), behavior: 'smooth' });
  $$('#thumbs button').forEach((b, i) => b.addEventListener('click', () => go(i)));
  $('#prev').addEventListener('click', () => go(cur() - 1));
  $('#next').addEventListener('click', () => go(cur() + 1));
  slides.addEventListener('scroll', () => $$('#thumbs button').forEach((b, j) => b.classList.toggle('on', cur() === j)), { passive: true });

  // paket seçimi: seçili pakette her çift için beden/renk/cinsiyet
  const sizes = ['36 - 40', '41 - 44'], colors = ['Lacivert', 'Siyah', 'Gri'], kinds = ['Erkek', 'Kadın'];
  const opt = (arr, v) => arr.map((x) => `<option${x === v ? ' selected' : ''}>${x}</option>`).join('');
  const state = () => ({ size: $('input[name=size]:checked').value, color: $('input[name=color]:checked').value });
  const fillSel = () => {
    const { size, color } = state();
    $$('.pk').forEach((pk) => {
      const inp = $('input', pk) && pk.querySelector('input'), sel = pk.querySelector('.sel');
      if (!inp.checked) { sel.innerHTML = ''; return; }
      const n = +inp.value;
      sel.innerHTML = `<span class="hd">Beden, Renk, Cinsiyet</span>` + Array.from({ length: n }, (_, i) =>
        `<span class="row">#${i + 1}<select aria-label="${i + 1}. çift beden">${opt(sizes, size)}</select><select aria-label="${i + 1}. çift renk">${opt(colors, color)}</select></span>`).join('');
    });
  };
  $('#cart').addEventListener('change', (e) => {
    if (e.target.name === 'size') $('#vSize').textContent = e.target.value;
    if (e.target.name === 'color') {
      $('#vColor').textContent = e.target.value;
      const i = imgs.findIndex((im) => im.dataset.color === e.target.value);
      if (i >= 0) go(i);
    }
    if (['size', 'color', 'pack'].includes(e.target.name)) fillSel();
  });
  fillSel();

  // sipariş: paket sepete; kapıda ödeme butonu doğrudan Shopify ödeme sayfasına
  const PACK = { 2: "2'li Paket", 4: "4'lü Paket", 8: "8'li Paket" };
  const variants = JSON.parse($('#cart').dataset.variants);
  const order = async (btn, to) => {
    const n = $('input[name=pack]:checked').value;
    const pairs = $$('.pk input:checked ~ .sel .row').map((r) => [...r.querySelectorAll('select')].map((x) => x.value.replace(/ /g, '')));
    const [size, color] = pairs[0];
    const v = variants.find((x) => x.option1 === PACK[n] && x.option2 === color && x.option3 === size);
    if (!v || !v.available) { alert('Bu seçim şu an stokta yok. Lütfen başka renk veya beden seç.'); return; }
    const groups = {};
    pairs.forEach(([s, c]) => { const k = `${c} ${s}`; groups[k] = (groups[k] || 0) + 1; });
    btn.setAttribute('aria-busy', 'true');
    try {
      if (to === '/checkout') await fetch('/cart/clear.js', { method: 'POST' });
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: { 'Çift seçimi': Object.entries(groups).map(([k, q]) => `${q}× ${k}`).join(', ') } }] }) });
      if (!r.ok) throw new Error((await r.json()).description || 'Sepete eklenemedi');
      location.href = to;
    } catch (e) { alert(e.message); btn.removeAttribute('aria-busy'); }
  };
  $('#atc').addEventListener('click', (e) => order(e.currentTarget, '/cart'));
  $('#codOpen').addEventListener('click', (e) => order(e.currentTarget, '/checkout'));
  $('#stBtn').addEventListener('click', (e) => order(e.currentTarget, '/checkout'));

  // yıldız satırı yalnız gerçek puan girilince
  const root = document.getElementById('bv'), AYAR = { puan: root.dataset.puan, yorumSayisi: root.dataset.yorum };
  if (AYAR.puan && AYAR.yorumSayisi) { $('#stars').hidden = false; $('#starsText').textContent = `${AYAR.puan} (${AYAR.yorumSayisi} İnceleme)`; }
  // video ekrana gelince yüklenir
  const vid = document.querySelector('video[data-src]');
  if (vid) new IntersectionObserver(([en], o) => { if (en.isIntersecting) { vid.src = vid.dataset.src; vid.play().catch(() => {}); o.disconnect(); } }, { rootMargin: '200px' }).observe(vid);
  // önce/sonra
  $('#baIn').addEventListener('input', (e) => $('#ba').style.setProperty('--x', e.target.value + '%'));

  // mobil sabit buton
  new IntersectionObserver(([en]) => $('#sticky').classList.toggle('on', !en.isIntersecting && en.boundingClientRect.top < 0)).observe($('#codOpen'));
})();
